module.exports = __webpack_public_path__ + "static/img/3.ff27c7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/3.jpg
// module id = nfmh
// module chunks = 1